import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'score-value',
  templateUrl: './score-value.component.html',
})
export class ScoreValueComponent implements OnInit {
  @Input() score: number | string;
  constructor() { }

  ngOnInit() {
  }

}
